import { useCookies } from 'react-cookie';

export const useManualInputCookies = () => {
	const [cookies, setCookie] = useCookies([
		'manualInputYear',
		'manualInputQuarter',
		'manualInputDivision',
		'manualInputCountry',
		'manualInputBrand',
		'manualInputCategories',
		'manualInputCompetitors'
	]);

	return {
		cookies,
		setCookie
	};
};
